module.exports = __webpack_public_path__ + "static/bg-66388515cdee81def8dee36761115e0d.png";